import { useMemo } from 'react';

export const useQuerySeed = () => useMemo(() => new URLSearchParams(window.location.search).get('seed') || '', []);
